import { $applyNodeReplacement } from "lexical";
import { SingleImageNode } from "./SingleImageNode.js";
function $createSingleImageNode(alt, id, description, mode) {
    return $applyNodeReplacement(new SingleImageNode(alt, id, description, mode));
}
function $isSingleImageNode(node) {
    return node instanceof SingleImageNode;
}
export { $createSingleImageNode, $isSingleImageNode };
